import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import NumberInput from "../NumberInput";

const CellNumberEditor = React.forwardRef((props, ref) => {
  const {
    decimalScale,
    value,
    isAllowed,
    InputProps,
    allowNegative = false, //reviewed by alston
    onChange = () => {},
  } = props;
  const [controlledValue, setControlledValue] = useState(value);
  const cellRef = useRef();
  const changeHandler = (values, e) => {
    setControlledValue(values.floatValue);
    onChange(values, e);
  };
  useImperativeHandle(ref, () => {
    return {
      getValue: () => controlledValue,
      isCancelAfterEnd: () => false,
    };
  });
  useEffect(() => {
    cellRef.current.focus({ preventScroll: true });
  }, []);
  useEffect(() => {
    setControlledValue(value);
  }, [value]);
  return (
    <NumberInput
      ref={cellRef}
      value={controlledValue}
      onValueChange={changeHandler}
      isAllowed={isAllowed}
      allowNegative={allowNegative}
      decimalScale={decimalScale}
      InputProps={{ ...InputProps, style: { background: "white" } }}
    />
  );
});
export default CellNumberEditor;
